module.exports = __webpack_public_path__ + "SG.png?97e190bbd4e54e1f1339036f1eb768cb";